"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _tssReact = require("tss-react");
var _tss = require("../styles/tss");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Reset styles are heavily inspired by destyle.css
 * https://raw.githubusercontent.com/nicolas-cusan/destyle.css/master/destyle.css
 */

/**
 * **❗️ DEPRECATED**
 *
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 *
 * @deprecated
 */
const CssBaseline = _ref => {
  let {
    withoutFontImport
  } = _ref;
  const {
    theme: {
      busbud: {
        colors,
        fontWeight,
        typography
      }
    }
  } = (0, _tss.useEmptyStyles)();
  return /*#__PURE__*/_react.default.createElement(_tssReact.GlobalStyles, {
    styles: [withoutFontImport || !typography.fontFace.import ? '' : `@import url("${typography.fontFace.import}");`, {
      /**
       * 1. Correct the line height in all browsers.
       * 2. Prevent adjustments of font size after orientation changes in iOS.
       * 3. Remove gray overlay on links for iOS.
       * 4. Change from `box-sizing: content-box` so that `width`
       *    is not affected by `padding` or `border`.
       */
      html: _objectSpread({
        lineHeight: 1.15,
        // 1
        WebkitTextSizeAdjust: '100%',
        // 2
        WebkitTapHighlightColor: 'transparent',
        // 3
        boxSizing: 'border-box',
        // 4
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
      }, typography.font.component.root),
      '*, *::before, *::after': {
        boxSizing: 'inherit',
        fontFamily: 'inherit'
      },
      body: {
        color: colors.text.primary.opaque,
        backgroundColor: colors.component.root.background,
        margin: 0,
        // Remove the margin in all browsers.

        '@media print': {
          // Save printer ink.
          backgroundColor: colors.background.primary.opaque
        },
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: colors.background.secondary.opaque
        }
      },
      /**
       * Headings
       */
      'h1, h2, h3, h4, h5, h6': {
        margin: 0
      },
      /**
       * Lists (enumeration)
       */
      'ul, ol': {
        margin: 0,
        padding: 0,
        listStyle: 'none'
      },
      /**
       * Vertical Rhythm
       */
      'p, table, blockquote, address, pre, iframe, form, figure, dl, label': {
        margin: 0
      },
      /**
       * Text-level semantics
       */
      'b, strong': {
        fontWeight: fontWeight.bold
      },
      small: {
        fontSize: '80%'
      },
      /**
       * Prevent `sub` and `sup` elements from affecting the line height in
       * all browsers.
       */
      'sub, sup': {
        fontSize: '75%',
        lineHeight: 0,
        position: 'relative',
        verticalAlign: 'baseline'
      },
      sub: {
        bottom: '-0.25em'
      },
      sup: {
        top: '-0.5em'
      },
      'audio, canvas, embed, iframe, img, object, svg, video': {
        display: 'block',
        verticalAlign: 'middle'
      }
    }]
  });
};
var _default = exports.default = CssBaseline;